// src/components/home2/Header3.jsx

import React, { useEffect, useRef, useState } from "react";
import "../View/WinnersHome/NewHomepage/newhome.css";
import menu from "../Images/Vector (16).png";
import logo2 from "../Images/Group 1171279193.png";
import darklogo from "../Images/darklogo.png";

import { NavLink, useLocation, useNavigate } from "react-router-dom";

// import HomeService from "../../Services/HomeService";
import HomeService from "../Services/HomeService";

import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { IoChevronDown } from "react-icons/io5";
import Sidebar2 from "./Sidebar2";
import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi2";

const Header3 = () => {
    const [navActive, setNavActive] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);

    const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);

    const [isCitySubMenuOpen, setIsCitySubMenuOpen] = useState(false);

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("theme") === "dark"
    );

    const citySubmenuRef = useRef();

    const location = useLocation();

    const navigate = useNavigate();


    const fetchCitiesWithCityDetails = async () => {
        try {
            const res = await HomeService.getCitiesWithCityDetails();

            console.log("city details", res);

            if (res?.status) {
                setCitiesWithCityDetails(res?.data);
            }
        } catch (error) {
            console.log(error);
        }
    };



    useEffect(() => {
        const token = localStorage.getItem("token");

        setIsLoggedIn(!!token);
    }, []);



    useEffect(() => {
        fetchCitiesWithCityDetails();
    }, []);



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setNavActive(true);
            } else {
                setNavActive(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                citySubmenuRef.current &&
                !citySubmenuRef.current.contains(e.target)
            ) {
                setIsCitySubMenuOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const [show, setShow] = useState(false);

    const sidebarfunc = () => {
        setShow(true);
    };
    const sidebarfunc2 = () => {
        setShow(false);
    };

    const handleAuthRedirect = () => {
        navigate("/profile");
    };



    useEffect(() => {

        if (darkMode) {
            document.body.classList.add("home2-dark-mode");
            localStorage.setItem("theme", "dark");
        } else {
            document.body.classList.remove("home2-dark-mode");
            localStorage.setItem("theme", "light");
        }

    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };

   useEffect(() => {
    const handleScroll = () => {
        if (window.scrollY > 20) {
            setNavActive(true);
        } else {
            setNavActive(false);
        }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
}, []);



    return (
        <>
            <header
                className={`home2-header ${navActive ? "home2-header-active" : ""
                    }`}
            >


                <div
                    className="home2-logo"
                    onClick={() => navigate("/")}
                >
                    <img
                        src={darkMode ? darklogo : logo2}
                        alt="logo" style={{width:"100px"}}
                    />
                </div>

                {/* NAV */}

                <div
                    className={`home2-nav-wrapper ${mobileMenu ? "home2-mobile-open" : ""
                        }`}
                >
                    <nav className="home2-nav">

                        <NavLink to="/" className="home2-nav-link">
                            Home
                        </NavLink>

                        <NavLink
                            to="/propertylist"
                            className="home2-nav-link"
                        >
                            Properties
                        </NavLink>

                        <NavLink
                            to="/communitylist"
                            className="home2-nav-link"
                        >
                            Community
                        </NavLink>

                        <NavLink
                            to="/aboutus"
                            className="home2-nav-link"
                        >
                            About
                        </NavLink>

                        <NavLink
                            to="/blog"
                            className="home2-nav-link"
                        >
                            Blog
                        </NavLink>

                        <NavLink
                            to="/career"
                            className="home2-nav-link"
                        >
                            Careers
                        </NavLink>

                        {/* CITIES */}

                        <div
                            ref={citySubmenuRef}
                            className="home2-city-dropdown"
                        >
                            <div
                                className="home2-nav-link city-link-home2"
                                onClick={() =>
                                    setIsCitySubMenuOpen(
                                        !isCitySubMenuOpen
                                    )
                                }
                            >
                                Cities

                                <IoChevronDown />
                            </div>

                            {isCitySubMenuOpen && (
                                <div className="home2-city-menu">

                                    {citiesWithCityDetails?.length === 0 ? (
                                        <p className="home2-city-item">
                                            No City Found
                                        </p>
                                    ) : (
                                        citiesWithCityDetails?.map((e, i) => {

                                            const city =
                                                e?.cityData?.name
                                                    ?.trim()
                                                    .replace(/\s+/g, "-");

                                            return (
                                                <p
                                                    key={i}
                                                    className="home2-city-item"
                                                    onClick={() => {
                                                        navigate(`/${city}`, {
                                                            state: {
                                                                id: e?.cityData?._id,
                                                            },
                                                        });

                                                        setIsCitySubMenuOpen(false);
                                                    }}
                                                >
                                                    {e?.cityData?.name}
                                                </p>
                                            );
                                        })
                                    )}

                                </div>
                            )}
                        </div>

                    </nav>

                    {/* BUTTONS */}

                    <div className="home2-header-btns">

                        {isLoggedIn ? (
                            <div onClick={sidebarfunc} className="menu_bar_wrapper_div">
                                <img src={menu} alt="Menu Icon" />
                            </div>
                        ) : (
                            <>
                                <button className="auth_button" onClick={handleAuthRedirect}>
                                    Sign Up / Log In
                                </button>

                                <button
                                    className="home2-join-btn"
                                    onClick={() =>
                                        navigate("/profile")
                                    }
                                >
                                    Join now
                                </button>
                            </>
                        )}

                        <button
                            className="home2-theme-toggle"
                            onClick={toggleDarkMode}
                        >
                            {darkMode ? (
                                <HiOutlineSun />
                            ) : (
                                <HiOutlineMoon />
                            )}
                        </button>

                    </div>
                </div>

                {/* MOBILE MENU */}

                <div
                    className="home2-mobile-menu-btn"
                    onClick={() =>
                        setMobileMenu(!mobileMenu)
                    }
                >
                    <HiOutlineMenuAlt3 />
                </div>
            </header>
            {show && <Sidebar2 sidebarfunc2={sidebarfunc2} />}
        </>
    );
};

export default Header3;